var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99982 3C10.4436 3 10.8529 3.23437 11.0779 3.61875L17.8279 15.1187C18.0561 15.5062 18.0561 15.9844 17.8342 16.3719C17.6123 16.7594 17.1967 17 16.7498 17H3.24982C2.80295 17 2.38732 16.7594 2.16545 16.3719C1.94357 15.9844 1.9467 15.5031 2.1717 15.1187L8.9217 3.61875C9.1467 3.23437 9.55607 3 9.99982 3ZM9.99982 7C9.5842 7 9.24982 7.33437 9.24982 7.75V11.25C9.24982 11.6656 9.5842 12 9.99982 12C10.4154 12 10.7498 11.6656 10.7498 11.25V7.75C10.7498 7.33437 10.4154 7 9.99982 7ZM10.9998 14C10.9998 13.7348 10.8945 13.4804 10.7069 13.2929C10.5194 13.1054 10.265 13 9.99982 13C9.73461 13 9.48025 13.1054 9.29272 13.2929C9.10518 13.4804 8.99982 13.7348 8.99982 14C8.99982 14.2652 9.10518 14.5196 9.29272 14.7071C9.48025 14.8946 9.73461 15 9.99982 15C10.265 15 10.5194 14.8946 10.7069 14.7071C10.8945 14.5196 10.9998 14.2652 10.9998 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b36161988c51b49dd77ee4780ede4ff5.svg";
export { ForwardRef as ReactComponent };